import { useEffect, useRef } from 'react';
import scrollBehavior from '@/shared/utils/scrollBehavior';

/**
 * Whenever `message` becomes set, scroll the returned ref's element to the
 * middle of the viewport and focus it. For an error the user caused from
 * somewhere else on the page (a submit button), which a phone user would
 * otherwise never see. The element needs tabIndex={-1} to take focus.
 */
export default function useRevealAlert(message) {
    const ref = useRef(null);

    useEffect(() => {
        const element = ref.current;
        if (!message || !element) return;
        element.scrollIntoView({ block: 'center', behavior: scrollBehavior() });
        element.focus({ preventScroll: true });
    }, [message]);

    return ref;
}
